import { type CreateMaterialInputType } from '@shelflix/schemas/material/create';
import { create } from 'zustand';

interface MaterialFormStore {
  formData: Partial<CreateMaterialInputType>;
  setFormData: (data: Partial<CreateMaterialInputType>) => void;
  resetForm: () => void;
}

export const useMaterialFormStore = create<MaterialFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
